import React, { useEffect, useState } from 'react'
import { AppDispatch, RootState } from '../../redux-stores/store'
import { useDispatch, useSelector } from 'react-redux'
import { fetchCollaborationsTasksThunk } from '../../redux-stores/slices/CollaborationsTasksSlice';
import { generateUniqueKey } from '../../utils/helpers';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from "swiper/modules";
import 'swiper/css';
import 'swiper/css/pagination';
import { Link } from 'react-router-dom';
const influencerPendingTasksFilters = { status: 'ongoing', page: 1, assignee: 'influencer', limit: 50 }
const filterId = generateUniqueKey(influencerPendingTasksFilters, ['page']);

const PendingSteps: React.FC = () => {

    const dispatch: AppDispatch = useDispatch();

    const collaborationsData = useSelector((state: RootState) => state.collaborationTasks.filtered_lists[filterId]);
    const collaborations = collaborationsData?.list ?? [];
    const loading = useSelector((state: RootState) => state.collaborationTasks.loading);

    const fetchPendingStepTasks = async () => {
        dispatch(fetchCollaborationsTasksThunk({ filters: influencerPendingTasksFilters }));
    }

    useEffect(() => {
        fetchPendingStepTasks();
    }, [])

    if(loading || collaborations.length === 0) return null;

    return (
        <div className="m-3 mt-0">
            <div className='pending-actions-card pb-3'>
                <h6 className="m-0 title">Pending Actions</h6>
                <Swiper pagination={true} autoplay={true} modules={[Pagination, Autoplay]} className="mySwiper pending-tasks-swiper pb-4" spaceBetween={10} slidesPerView={1.1}>
                    {
                        collaborations.map((collaboration, index) => {

                            const activeStep = [...(collaboration.active_steps ? collaboration.active_steps.filter((step) => step.can_process) : [])].sort((a, b) => a.sort_order - b.sort_order)[0];

                            return (
                                <SwiperSlide key={index}>
                                    <div className="pending-task-card position-relative gap-2">
                                        <div className="d-flex gap-2">
                                            <div className="bg-image bgc-content" style={{ backgroundImage: `url(${collaboration.campaign.hero_img_url})`, height: '40px', width: '40px', borderRadius: '10px' }}></div>
                                            <div className="d-flex flex-column gap-1 justify-content-center">
                                                <h6 className="collab-campaign-name">{collaboration.campaign.name}</h6>
                                                {/* <span className="collab-campaign-brand-name">{collaboration.campaign.}</span> */}
                                            </div>
                                        </div>
                                        <div className="w-100 d-flex flex-column gap-2">
                                            {
                                                activeStep.can_process &&
                                                <Link to={{pathname: `/collaborations/${collaboration.campaign.uuid}/milestone/${collaboration.active_milestone.id}`}} className="theme-btn theme-btn-primary">{activeStep.gig_step.cta_text ?? 'Take Action*'}</Link>
                                            }
                                        </div>
                                    </div>
                                </SwiperSlide>
                            )
                        })
                    }
                </Swiper>
            </div>
        </div>
    )
}

export default PendingSteps